// import Logo from "../assets/Aspetto_Login.png";
import AuthSideImg from "./AuthSideImg";
import { IconMail } from "@tabler/icons-react";
import usePostRequest from "../../hooks/usePostRequest";
import { useState } from "react";
import { API_ENDPOINTS, aspetto_logo } from "../../constant/_constant";
import { useParams } from "react-router-dom";
import { validatePassword } from "../../utils/_helpers";
import PasswordInput from "../../components/PasswordInput";
import { toast } from "react-toastify";

const ResetPassword = () => {
  const { token } = useParams();
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });

  const { isLoading, postData } = usePostRequest(API_ENDPOINTS.RESET_PASSWORD);

  const handleChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onSuccess = (response) => {
    setFormData({
      password: "",
      confirmPassword: "",
    });
    toast.success(response.message);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      password: formData.password,
      token,
    };
    postData(payload, onSuccess);
  };

  const { message, className, isValid } = validatePassword(
    formData.password,
    formData.confirmPassword
  );

  return (
    <div className="row g-0 flex-fill">
      <div className="col-12 col-lg-6 col-xl-4 border-top-wide border-warning d-flex flex-column justify-content-center">
        <div className="container container-tight my-5 px-lg-5">
          <div className="text-center w-50 mb-3 m-auto">
            <img src={aspetto_logo} height={80} alt="aspetto_logo" />
          </div>
          <h2 className="heading_login text-center mb-3">Reset Password</h2>
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="mb-3">
              {/* <label className="form-label">New Password</label> */}
              <PasswordInput
                id="password"
                name="password"
                required={true}
                value={formData?.password}
                onChange={handleChange}
                customHeading="New Password"
              />
              {/* <input
                id="password"
                type="password"
                className="form-control"
                name="password"
                required
                value={formData.password}
                onChange={handleChange}
              /> */}
            </div>
            <div className="mb-3">
              {/* <label className="form-label">Confirm New Password</label> */}
              <PasswordInput
                id="password-confirm"
                name="confirmPassword"
                required={true}
                value={formData?.confirmPassword}
                onChange={handleChange}
                customHeading="Confirm New Password"
              />
              {/* <input
                id="password-confirm"
                type="password"
                className="form-control"
                name="confirmPassword"
                required
                value={formData.confirmPassword}
                onChange={handleChange}
              /> */}
            </div>
            <span className={`text-center ${className}`} role="alert">
              {message}
            </span>
            <div className="form-footer">
              <button
                type="submit"
                className={`btn btn-theme w-100 ${
                  isLoading ? "btn-loading" : ""
                }`}
                disabled={isLoading || !isValid}
              >
                <IconMail size={20} className="icon" />
                Reset Password
              </button>
            </div>
          </form>
        </div>
      </div>
      <AuthSideImg />
    </div>
  );
};

export default ResetPassword;
